import { Route } from '@angular/router'
import { accessGuard } from '@mattrika/benefit-core'
import { PageLayout } from './layouts/page-layout.enum'
import { setLayout } from './layouts/set-layout.resolver'
import { AdminRoutes } from './pages/admin/admin.routes'
import { ClientRoutes } from './pages/client/client.routes'
import { PublicRoutes } from './pages/public/public.routes'
import { TempRoutes } from './pages/temp/temp.routes'
import { VendorRoutes } from './pages/vendor/vendor.routes'

export const appRoutes: Route[] = [
    {
        path: '',
        runGuardsAndResolvers: 'always',
        resolve: { layout: setLayout(PageLayout.Client) },
        children: [...PublicRoutes, ...TempRoutes],
    },
    {
        path: 'deals',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: 'client-admin',
        canActivate: [
            accessGuard({
                requireGroups: ['client'],
                requireOwner: true,
                options: { redirectTo: ['/client/dashboard'] },
            }),
        ],
        resolve: { layout: setLayout(PageLayout.ClientDashboard) },
        loadComponent: () =>
            import('./pages/client/page-client-admin/page-client-admin.component').then(
                (c) => c.PageClientAdminComponent,
            ),
        data: { pageTitle: 'Client Admin Dashboard' },
    },
    {
        path: 'client',
        canActivate: [accessGuard({ requireGroups: ['client'] })],
        resolve: { layout: setLayout(PageLayout.ClientDashboard) },
        children: [...ClientRoutes],
    },
    {
        path: 'vendor',
        canActivate: [accessGuard({ requireGroups: ['vendor'] })],
        resolve: { layout: setLayout(PageLayout.Vendor) },
        children: [...VendorRoutes],
    },
    {
        path: 'admin',
        canActivate: [accessGuard({ requireGroups: ['superAdmin'] })],
        resolve: { layout: setLayout(PageLayout.Default) },
        children: [...AdminRoutes],
    },
    {
        path: '404',
        loadComponent: () =>
            import('./pages/public/page-not-found/page-not-found.component').then(
                (c) => c.PageNotFoundComponent,
            ),
        resolve: { layout: setLayout(PageLayout.Blank) },
    },
    {
        path: '**',
        redirectTo: '404',
    },
]
